import { SystemIcon } from "@justworkshr/milo-icons";
import styles from "./BackToProfile.module.css";
import { useTranslation } from "react-i18next";
import { useProfileRedirectUrl } from "../../../hooks/useProfileRedirectUrl";
import { buildWebPath } from "lib/resource-finder";

export default function BackToProfile() {
  const { t } = useTranslation();
  const profileLink = useProfileRedirectUrl();

  // For external URLs (Neon), use as-is
  // For internal paths, prepend /cf/ and let buildWebPath handle it
  const href = profileLink.startsWith("http")
    ? profileLink
    : buildWebPath(`/cf${profileLink}`);

  return (
    <a href={href}>
      <div className={styles.backContainer}>
        <SystemIcon iconName="arrow-left" color="brand" size="small" />
        <span>{t("Back to Profile")}</span>
      </div>
    </a>
  );
}
